import { BigNumber } from 'ethers'
import { VESISConfig } from '~/types/config'

export function getNextRewardAt(config: VESISConfig): BigNumber {
	const { week } = config

	const now = parseInt(`${Date.now() / 1000}`)
	return BigNumber.from(now).add(week).div(week).mul(week)
}
